import { render, staticRenderFns } from "./ClienteCreate.vue?vue&type=template&id=3737cdd6&"
import script from "./ClienteCreate.vue?vue&type=script&lang=js&"
export * from "./ClienteCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports